export default function Plus({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 6H13V11H18V13H13V18H11V13H6V11H11V6Z" fill="currentColor" />
    </svg>
  )
}
